<div class="licenses-page">
  <h1>Activations Medispring Light</h1>

  <div class="licenses-toolbar">
    <mat-form-field class="search-field" appearance="outline">
      <mat-label>Recherche</mat-label>
      <input
        matInput
        [value]="searchTerm()"
        (input)="updateSearchTerm($any($event.target).value)"
        placeholder="Nr INAMI"
      />
    </mat-form-field>

    <button mat-flat-button type="button" color="primary" (click)="activateLicense()">
      Activer une licence
    </button>
  </div>

  <table mat-table [dataSource]="filteredOptions()" class="override-table">
    <ng-container matColumnDef="nihii">
      <th mat-header-cell *matHeaderCellDef>Nr INAMI</th>
      <td mat-cell *matCellDef="let option">{{ option.nihii }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let option">
        <button
          mat-icon-button
          type="button"
          color="warn"
          aria-label="Désactiver la licence"
          (click)="deactivateLicense(option.nihii)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['nihii', 'actions']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['nihii', 'actions']"></tr>
  </table>
</div>
